import React from 'react'

import './MyAliadasList.scss'
import SearchResultItem from 'components/SearchResultItem'

function MyAliadasList ({ aliadas, searchProps, reserveAliada }) {
  const MAX_RESULTS = 3
  return (
    <div>
      <h3>❤️ Mis Aliadas</h3>

      <div className='MyAliadasList'>
        {
          aliadas
            .slice(0, MAX_RESULTS)
            .map(aliada => (
              <SearchResultItem
                key={aliada.id}
                aliada={aliada}
                searchProps={searchProps}
                reserveAliada={reserveAliada}
                />
            ))
        }
      </div>
    </div>
  )
}

export default MyAliadasList



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/Search/components/MyAliadasList/MyAliadasList.js